import useProfile from '@hooks/useProfile';
import { animated, useTransition } from 'react-spring';
import styles from './header-profile.module.scss';
import eye from '@assets/svg/eye-public.svg';
import { ReactComponent as Twitch } from '@assets/svg/twitch.svg';
import { BREAKPOINTS } from '@consts/ui';
import useReduxState from '@hooks/useReduxState';

function UserActions() {
  return (
    <div className={styles.action}>
      <button className={styles.edit}>Edit Profile</button>
      <div className={styles.special_actions}>
        <button className={styles.public}>
          <img src={eye} alt='eye' />
          Public
        </button>
        <div className={styles.twitch}>
          <Twitch />
        </div>
      </div>
    </div>
  );
}

function UserInfo() {
  const user = useProfile();
  const level = Math.floor(user.expirience / 1000);
  const levelLeft = user.expirience - level * 1000;
  const percentage = (levelLeft / 1000) * 100;

  const levelbartrans = useTransition(user, {
    from: {
      width: '0%',
    },
    enter: {
      width: `${percentage}%`,
    },
    leave: {
      width: '0%',
    },
  });

  return (
    <div className={styles.user}>
      <img src={user.avatar_url} alt='avatar' />
      <div className={styles.user_level}>{level}</div>
      <div className={styles.user_data}>
        <h1>{user.username}</h1>
        <div className={styles.expirience}>
          <p>Level {level}</p>
          <div className={styles.bar}>{levelbartrans((style, item) => item && <animated.div className={styles.thumb} style={style} />)}</div>
          <div className={styles.info}>
            <p>Experience</p>
            <p>
              {levelLeft}
              /1000
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function HeaderProfile(): JSX.Element {
  const [{ windowWidth }] = useReduxState((state) => state.ui);
  const isDesktop = windowWidth >= BREAKPOINTS.LG;

  return (
    <div className={styles.header_profile}>
      <UserInfo />
      {isDesktop && <UserActions />}
    </div>
  );
}
